import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import userService from "../../services/userService";
import { IconCheck, IconAlertTriangle, IconLoader2 } from '@tabler/icons-react';

const Activation = () => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const locationUrl = useLocation();

    const [loading, setLoading] = useState(true);
    const [activationSuccess, setActivationSuccess] = useState(false);

    const queryParams = new URLSearchParams(locationUrl.search);
    const singleValue = queryParams.get('activation');

    useEffect(() => {
        const activate = async () => {
            if (singleValue) {
                try {
                    const result = await userService.activateUser({ activationCode: singleValue });
                    if (result === "Aktivasyon OK") {
                        toast.success(t('mesajAktivasyonBasarili'));
                        setActivationSuccess(true);
                    } else {
                        toast.warning(result);
                        setActivationSuccess(false);
                    }
                } catch (error) {
                    toast.error(t('mesajSunucuTarafiHatasi') || "Server Error");
                    setActivationSuccess(false);
                } finally {
                    setLoading(false);
                }
            } else {
                setLoading(false);
                setActivationSuccess(false);
            }
        };
        activate();
    }, [singleValue, t]);

    const changeLang = async (lang) => {
        await i18n.changeLanguage(lang);
        localStorage.setItem('siteLang', lang);
    };

    return (
        <div style={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'linear-gradient(135deg, #1e2a38 0%, #2563a8 100%)',
            padding: '24px',
        }}>
            {/* Logo Alanı */}
            <div className="mb-4 text-center">
                <img src="Kama3DLogo.svg" alt="Kama 3D Logo" style={{ width: 180 }} />
            </div>

            {/* Activation Kartı */}
            <div className="card shadow border-0 rounded-4" style={{ width: '100%', maxWidth: '480px', overflow: 'hidden', backgroundColor: '#ffffff' }}>
                {/* Kart Başlığı ve Dil Değiştirici */}
                <div className="d-flex align-items-center justify-content-between px-4 pt-4 pb-2">
                    <h5 className="fw-bold text-dark m-0">{t('baslikAktivasyon')}</h5>
                    <div style={{ display: 'flex', gap: '8px' }}>
                        <img
                            src="flag-tr.png"
                            alt="TR"
                            onClick={() => changeLang('tr')}
                            style={{ width: 22, cursor: 'pointer', borderRadius: 3, opacity: i18n.language.startsWith('tr') ? 1 : 0.35, transition: 'opacity 0.2s' }}
                        />
                        <img
                            src="flag-en.png"
                            alt="EN"
                            onClick={() => changeLang('en')}
                            style={{ width: 22, cursor: 'pointer', borderRadius: 3, opacity: i18n.language.startsWith('en') ? 1 : 0.35, transition: 'opacity 0.2s' }}
                        />
                    </div>
                </div>

                <div className="card-body p-4 text-center">
                    {loading ? (
                        <div className="py-5">
                            <IconLoader2 size={42} className="text-primary mb-3" style={{ animation: 'spin 1s linear infinite' }} />
                            <p className="text-muted small mb-0">{i18n.language.startsWith('tr') ? 'Aktivasyon kontrol ediliyor...' : 'Verifying activation...'}</p>
                            <style>{`
                                @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
                            `}</style>
                        </div>
                    ) : activationSuccess ? (
                        <div>
                            <div className="mb-3">
                                <div style={{ width: 64, height: 64, borderRadius: '50%', background: '#dcfce7', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <IconCheck size={36} className="text-success" />
                                </div>
                            </div>
                            <div className="alert alert-success border-0 shadow-sm mb-4 text-start small">
                                {t('mesajAktivasyonSayfasi')}
                            </div>
                            <button
                                className="btn btn-primary w-100 py-2 fw-bold"
                                onClick={() => navigate("/login")}
                            >
                                {t('butonGirisYap').toUpperCase()}
                            </button>
                        </div>
                    ) : (
                        <div>
                            <div className="mb-3">
                                <div style={{ width: 64, height: 64, borderRadius: '50%', background: '#fee2e2', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <IconAlertTriangle size={36} className="text-danger" />
                                </div>
                            </div>
                            <div
                                className="alert alert-danger border-0 shadow-sm mb-4 text-start small"
                                dangerouslySetInnerHTML={{ __html: t('mesajAktivasyonHatali') }}
                            />
                            <button
                                className="btn btn-outline-secondary w-100 py-2 fw-bold"
                                onClick={() => navigate("/login")}
                            >
                                {t('butonGeri')}
                            </button>
                        </div>
                    )}
                </div>
            </div>

            <div className="mt-4 text-white-50 small">
                © {new Date().getFullYear()} Kama 3D Doküman Merkezi
            </div>
        </div>
    );
};

export default Activation;
